import {ACES, Roles} from "../components/admin/user/UserManager.types";
import {ClientWorkspace} from "../redux/models/appEnvironment";

export const getExistingAces = (
  environmentId: number,
  availableWorkspacesForAce: Pick<ClientWorkspace, "id">[],
  aces: Pick<ACES, 'target' | 'roles'>[]
): { [p: string]: Roles[] | undefined } => {
  return {
    [`environment:${environmentId}`]: [],
    ...availableWorkspacesForAce.reduce((acc, cur) => ({...acc, [`workspace:${cur.id}`]: []}), {}),
    // eslint-disable-next-line no-warning-comments
    ...(aces || []).reduce((acc, {target, roles}) => ({
      ...acc,
      [target]: roles,
    }), {}),
  }
}